// import $ from 'jquery';
import initFeatures from "./feature";
import initHeaderHeightCalculation from './headerheight';
import initAccordions from './accordion';
import initSlickCarousels from './slick';
import initSlideout from './slideout';
import initTableOfContents from './tableOfContents';
import initGoogleMaps from './googlemaps';
import initScrollToTop from './scrollToTop';
import initLightGallery from "./lightgallery";
import Foundation from 'foundation-sites';
import initIsotopeFilter from "./isotope";
import initTimeline from "./timeline";
import initTimelines from "./timeline";
import AOS from "aos";
import initLazy from "./lazy";

/**
 * init all includes Modules with this starter function
 */

function initAllModules() {

	// init basic features
	initFeatures();

	// calculate header height on page load
	initHeaderHeightCalculation();

	// Init the accordion feature
	initAccordions();

	// init Google Maps feature
	initGoogleMaps();

	// init scroll to top button feature
	initScrollToTop();

	// slick slider and carousel elements
	initSlickCarousels();

	// init slideout
	initSlideout();

	// init table of contents navigation
	initTableOfContents();

	// lightgallery
	initLightGallery();

	// Isotope masonry and filter
	initIsotopeFilter();

	// Timeline
	initTimelines(".js--timeline");

	// image lazyload
	initLazy();

	// init aos animations
	AOS.init({
		throttleDelay: 80,
		duration: 900
	});
}


/**
 * Init some Javascript Modules for frontend behaviors
 */

initAllModules();
